import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=19a0fbd2&scoped=true&"
import script from "./Availability.vue?vue&type=script&lang=js&"
export * from "./Availability.vue?vue&type=script&lang=js&"
import style0 from "./Availability.vue?vue&type=style&index=0&id=19a0fbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a0fbd2",
  null
  
)

export default component.exports